export default "__VITE_ASSET__946134fc__"